/* tslint:disable */
/* eslint-disable */
export enum CreditCreationConflictType {
  RequestedCreditEqualsCurrentCredit = 'requested_credit_equals_current_credit',
  RequestedCreditEqualsPendingCreditRequest = 'requested_credit_equals_pending_credit_request'
}
